import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  ReceiptNoNestingFragment,
  ReceiptSettingsDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { Receipt as ReceiptTemplateEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import ReceiptTemplate from "../../data/model/ReceiptTemplate";
import { listOptions, listVariables } from "../constants";

import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const receiptTemplatesQuery = gql`
  ${ReceiptNoNestingFragment}
  ${ReceiptSettingsDeepNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
  query GetReceiptTemplates(${listVariables}) {
    receipts(${listOptions}) {
        items{
            ...ReceiptNoNesting
            settings {
                ...ReceiptSettingsDeepNesting
            }
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
   
    }
  }
`;

export const receiptTemplateDefinition = new EntityResourceDefinition<
  ReceiptTemplateEntity,
  ReceiptTemplate
>({
  entity: "receipt_template",
  query: receiptTemplatesQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.receiptTemplateType.id = fetchedEntity.defaultTemplateType;
    newEntity.name = fetchedEntity.name || "";
    newEntity.enabled = fetchedEntity.enabled;
    newEntity.settings = fetchedEntity.settings || null;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "receipts", receiptTemplatesQuery, options);
  },
});
